var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualExcellanceImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 39C13.3137 39 16 36.3137 16 33C16 29.6863 13.3137 27 10 27C6.68629 27 4 29.6863 4 33C4 36.3137 6.68629 39 10 39Z",
    fill: "#00A9DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39C55.3137 39 58 36.3137 58 33C58 29.6863 55.3137 27 52 27C48.6863 27 46 29.6863 46 33C46 36.3137 48.6863 39 52 39Z",
    fill: "#00A9DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1014 12L31.0014 9.95L34.9014 12L34.1514 7.66L37.3114 4.58L32.9514 3.95L31.0014 0L29.0514 3.95L24.6914 4.58L27.8514 7.66L27.1014 12Z",
    fill: "#00A9DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7483 20L51.9983 18.29L55.2483 20L54.6283 16.38L57.2583 13.82L53.6183 13.29L51.9983 10L50.3783 13.29L46.7383 13.82L49.3683 16.38L48.7483 20Z",
    fill: "#00A9DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74828 20L9.99828 18.29L13.2483 20L12.6283 16.38L15.2583 13.82L11.6183 13.29L9.99828 10L8.37828 13.29L4.73828 13.82L7.36828 16.38L6.74828 20Z",
    fill: "#00A9DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27C39 22.58 35.42 19 31 19C26.58 19 23 22.58 23 27C23 31.42 26.58 35 31 35C35.42 35 39 31.42 39 27ZM31 32C28.79 32 27 30.21 27 28H29C29 29.1 29.9 30 31 30C32.1 30 33 29.1 33 28H35C35 30.21 33.21 32 31 32Z",
    fill: "#00A9DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 44C44 39.03 39.97 35 35 35H31L34 45L31 49L28 45L31 35H27C22.03 35 18 39.03 18 44V60H44V44Z",
    fill: "#00A9DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9995 39H48.9995C47.6295 39 46.3495 39.4 45.2695 40.09C45.7395 41.31 45.9995 42.62 45.9995 44V56H61.9995V46C61.9995 42.13 58.8695 39 54.9995 39Z",
    fill: "#00A9DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44C16 42.62 16.27 41.3 16.73 40.09C15.65 39.41 14.37 39 13 39H7C3.13 39 0 42.13 0 46V56H16V44Z",
    fill: "#00A9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualExcellanceImg2);
export default __webpack_public_path__ + "static/media/individualExcellanceImg2.b881408a7a8426d6cf63e98481abd016.svg";
export { ForwardRef as ReactComponent };